import { WellPermissions } from '../app/hooks/use-well-permissions'

export type User = {
  id?: string
  firstName?: string
  lastName?: string
  email?: string
  council?: string
  councilId?: number
  companyId?: number
  permissions?: Array<string>
  token: Token
  auth_method?: AuthMethod
  objectPermissions?: WellPermissions
}

export enum Permissions {
  VIEW_WELL = 'global.view_well',
  EDIT_WELL = 'global.edit_well',
  EDIT_WELL_UNSCOPED = 'global.edit_well_unscoped',
  DELETE_WELL_DATA = 'global.delete_well_data',
  VIEW_ADDITIONAL_DOCUMENTS = 'global.view_additional_documents_unscoped',
  EDIT_EXTERNAL_DOCUMENTS = 'global.edit_external_documents_unscoped',
  ADD_PRIVATE_NOTE = 'global.add_private_note',
  MAINTAIN_ALL_USERS = 'global.maintain_all_users',
  MAINTAIN_ORG_USERS = 'global.maintain_org_users',
  MAINTAIN_ALL_ORG_DETAILS = 'global.maintain_all_org_details',
  CREATE_WELL = 'global.create_well',
  CREATE_WELL_UNSCOPED = 'global.create_well_unscoped',
  VIEW_WELL_OWNER = 'global.view_well_owner',
  REVIEW_WELL = 'global.review_well',
  EXTERNAL_API_USER = 'global.external_api_user',
  VIEW_DRINKING_WATER_INFO = 'global.view_drinking_water_info',
  MAINTAIN_API_CLIENTS = 'global.maintain_api_clients',
}

export type Token = string | false
export type AuthMethod = 'Bearer' | 'Token'
